<template>
  <div class="form-group">
    <label for="monitoring_cluster" class="control-label">{{ label }}</label>
    <Select2
        :options="selectOptions"
        v-model="selected"
    />

    <input
        type="hidden"
        name="monitoring_cluster"
        :value="selected"
    >
  </div>
</template>

<script>
export default {
  name: "MonitoringClusterSelection",

  props: {
    cluster: {
      type: Array,
      required: true
    },
    value: {
      default: null
    },
    label: {
      type: String,
      default: ''
    },
  },

  data() {
    return {
      selected: this.value
    }
  },

  computed: {
    selectOptions() {
      return this.cluster.map(item => ({
        id: item.id,
        text: item.name
      }))
    }
  },

  watch: {
    value(newValue) {
      this.selected = newValue
    },

    selected(val) {
      this.$emit("input", val)
    }
  }
}
</script>